import { Phone, Mail, Clock, Home, Sparkles } from 'lucide-react';

const SERVICE_LINKS = ['Residential Cleaning', 'Commercial Cleaning', 'Deep Cleaning', 'Post-Construction Cleaning', 'Move-In / Move-Out Cleaning'];
const COMPANY_LINKS = [
  { label: 'How It Works', href: '#how-it-works' },
  { label: 'Reviews', href: '#reviews' },
  { label: 'Service Areas', href: '#areas' },
  { label: 'Get a Quote', href: '#quote' },
];
const AREAS = ['Surrey', 'Vancouver', 'Langley', 'Coquitlam', 'Richmond', 'Burnaby'];

function Col({ title, children, testid }) {
  return (
    <div data-testid={testid}>
      <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-mint-vibrant mb-5">{title}</p>
      <ul className="space-y-2.5">{children}</ul>
    </div>
  );
}

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative bg-obsidian grain overflow-hidden border-t border-white/10">
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 pt-16 lg:pt-20 pb-8">
        <div className="grid sm:grid-cols-2 lg:grid-cols-12 gap-10 lg:gap-8">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-3.5">
            <img src="/logo.png" alt="GMP Solution" className="h-14 rounded-lg bg-white px-3 py-2 object-contain ring-1 ring-white/20" />
            <span className="font-display font-extrabold text-white text-2xl tracking-tight">GMP Solution</span>
          </div>
            <p className="mt-5 text-stone-400 text-sm leading-relaxed max-w-xs">
              Residential and commercial cleaning for homes, offices, restaurants and retail —
              dependable people, spotless results.
            </p>
            <p className="mt-4 font-mono text-[11px] text-stone-500 leading-relaxed">
              Serving {AREAS.join(' · ')} & surrounding communities
            </p>
          </div>
          <div className="lg:col-span-3">
            <Col title="Services" testid="footer-services">
              {SERVICE_LINKS.map((s) => (
                <li key={s}>
                  <a href="#services" data-testid={`footer-link-${s.toLowerCase().replace(/[^a-z]+/g, '-')}`} className="text-stone-300 hover:text-white text-sm transition-colors">
                    {s}
                  </a>
                </li>
              ))}
            </Col>
          </div>
          <div className="lg:col-span-2">
            <Col title="Company" testid="footer-company">
              {COMPANY_LINKS.map((l) => (
                <li key={l.label}>
                  <a href={l.href} data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, '-')}`} className="text-stone-300 hover:text-white text-sm transition-colors">
                    {l.label}
                  </a>
                </li>
              ))}
            </Col>
          </div>
          <div className="lg:col-span-3">
            <Col title="Contact" testid="footer-contact">
              <li className="flex items-start gap-2 text-stone-300 text-sm">
                <Phone size={14} className="text-mint-vibrant mt-0.5 shrink-0" />
                <a href="tel:+16473900855" className="hover:text-white transition-colors">+1 (647) 390-0855</a>
              </li>
              <li className="flex items-start gap-2 text-stone-300 text-sm">
                <Mail size={14} className="text-mint-vibrant mt-0.5 shrink-0" />
                <a href="mailto:infogmpsolution@gmail.com" className="hover:text-white transition-colors break-all">infogmpsolution@gmail.com</a>
              </li>
              <li className="flex items-start gap-2 text-stone-300 text-sm">
                <Clock size={14} className="text-mint-vibrant mt-0.5 shrink-0" />
                8:00 AM – 11:00 PM, 7 days a week
              </li>
            </Col>
          </div>
        </div>

        <div className="mt-14 pt-7 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="font-mono text-[11px] text-stone-500 tracking-wide">
            © {new Date().getFullYear()} GMP Solution. All Rights Reserved.
          </p>
          <a href="#top" data-testid="footer-privacy" className="font-mono text-[11px] text-stone-500 hover:text-white transition-colors">
            Privacy Policy | Terms of Service
          </a>
        </div>
      </div>
    </footer>
  );
}
